<template>
    <div
        :class="[
            'cursor-pointer',
            'whitespace-nowrap',
            'break-keep',
            danger ? 'hover:bg-theme-danger-bg' : 'hover:bg-theme-icon-bg',
            'rounded-md',
            'p-2',
        ]"
    >
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        /** Tints the hover red, for an item that deletes. */
        danger: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
